import React from "react";
import { useSelector } from "react-redux";
import { useFlag } from '@innovid/feature-flags-react';
import { LinkAction, BasicAction } from "widgets/ActionMenu";
import { previewVersion } from "widgets/grid/cells/CreativeActionLists/PreviewActions";
import { FEATURE_FLAGS } from 'featureFlag/featureFlag';

const PREVIEW = {
	component: ({ libraryId, dependentValues }) => {
		let {  creativeId, versionId } = dependentValues;
		return(<LinkAction
			key="preview-version"
			name="Preview"
			iconName="preview"
			iconStyle="far"
			tooltipContent="Preview"
			path={`/library/${libraryId}/creative/${creativeId}/versions/${versionId}/modal/preview-version/`} />
		);
	},
};

const PREVIEW_CREATIVE_PRIVATE = {
	name:"Preview Creative",
	component: ({ dependentValues }) => {
		const creative = useSelector(state => state.creativeDetails);
		const forceNewPreview = useFlag(FEATURE_FLAGS.NEW_PREVIEW_LINKS);
		const { versionName } = dependentValues || {};

		return (
			<BasicAction
				className="external-link-action preview-actions"
				iconName="fas fa-image"
				name="Preview Creative (Private)"
				handleClick={() => {
					previewVersion(creative, versionName, forceNewPreview);
				}}
			/>
		);
	},
};

export const VERSIONS_PREVIEW_ACTIONS = [
	PREVIEW,
	PREVIEW_CREATIVE_PRIVATE,
];
